<template lang="html">
  <div class="dialog-mask" v-show="innerShow">
    <div class="dialog-container" >
      <div class="dialog-header">
        <span class="dialog-title" v-if="title">{{title}}</span>
        <span class="icon-close" @click="close"></span>
      </div>
      <div class="dialog-content">
        <slot name="content">
          <div class="content-detail" v-html="data">

          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "commonshowdialog",
  props: {
    title: {
      type: String,
      default(){
        return ""
      }
    },
    show: {
      type: Boolean,
      default(){
        return false
      }
    },
    data: {
      type: String,
      default(){
        return "";
      }
    }
  },
  data(){
    return {
      innerShow: false
    }
  },
  watch: {
    show(newVal){
      this.innerShow = this.show;
    },
    innerShow: {
      handler(newV, oldV){
        if(newV){
          document.body.style.overflow = "hidden";
        }
        else{
          document.body.style.overflow = "auto";
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 关闭
    close(){
      this.innerShow = false;
      this.$emit("update:show", this.innerShow);
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~@/common/stylus/mixin.styl";
.dialog-mask
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 9999
  background-color: rgba(0,0,0,0.2)
  .dialog-container
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    width: 7.50rem
    // min-height: 145px

    border-radius: 0.13rem
    background-color: #F3F3F3
    overflow: hidden
    .dialog-header
      position: relative
      height: 0.46rem
      display: flex
      align-items: center
      justify-content: center
      &::after
        content: " "
        position: absolute
        left: 0
        right: 0
        bottom: 0
        width: 100%
        height: 1px
        background-repeat: no-repeat
        background-size: 100% 100%
        bg-image("~@/images/bg/1px-line-bg")
      .dialog-title
        font-size: 0.22rem
        color: #191919
      .icon-close
        position: absolute
        right: 18px
        top: 50%
        transform: translate(0, -50%)
        width: 0.14rem
        height: 0.14rem
        background-repeat: no-repeat
        background-size: 100% 100%
        bg-image("~@/images/icon/icon-close")
        cursor: pointer
    .dialog-content
      position: relative
      padding: 0.25rem 0.6rem
      height: 4.8rem
      display: flex
      // justify-content: center
      box-sizing: border-box
      overflow-y: auto
      .content-detail
        line-height: 0.16rem
        white-space: pre-wrap
        font-size: 0.11rem
        color: #7A7A7A
</style>
